import { useState, useContext } from "react";
import { CustomTourTooltip } from "./CustomTourToolTip";
import { useHistory } from "react-router-dom";
import { ToolContext } from "../../../../core/context/ToolContext";
import Joyride, { EVENTS, ACTIONS, STATUS } from 'react-joyride';

export const JoyrideWrapper = ({run, steps, setter, end, featureName, p_name, controls = true, disableScrolling = false})=>{
	const {promo_product_state, personalization_state, service_state} = useContext(ToolContext)
	const { templates: promoTemplates } = promo_product_state
	const { templates: serviceTemplates } = service_state
	const {modalTriggers, toOpenBankForm, openBankForm} = personalization_state
	const [stepIndex, setStepIndex] = useState(0)
	const nav = useHistory();

	const actionExecuter = ({ key }) => {
		const templates = p_name === 'productPromoPage' ? promoTemplates : serviceTemplates
		switch (key) {
			case 'TEMPLATE_PROMO_PAGE':
				templates.set((p) => ({ ...p, preview: { toggled: true } }))
				break;
			case 'TEMPLATE_PROMO_PAGE_DISABLED':
				templates.set((p) => ({ ...p, preview: { toggled: false } }))
				break;
			default:
      			console.warn('Unhandled Joyride action:', key);
		}
	}

	const waitForElement = (selector, maxTries = 10, interval = 100) => {
		let tries = 0;
		return new Promise((resolve, reject) => {
			const check = () => {
				const el = document.querySelector(selector);
				if (el) {
					resolve(el); // element found
				} else {
					tries++;
					if (tries >= maxTries) {
						reject(new Error(`Element not found: ${selector}`));
					} else {
						setTimeout(check, interval); // retry after delay
					}
				}
			};
			check();
		});
	};

	const handleCallback = async (data) => {
		const { action, type, status, step, index } = data;
		if (type === EVENTS.TARGET_NOT_FOUND) {
			console.error('Waiting for target:', step.target);
			return;
		}
		if (type === EVENTS.STEP_AFTER && action === ACTIONS.NEXT) {
			const nextStep = steps[index + 1]
			if (nextStep?.action) {
				actionExecuter(nextStep.action);
			}
			if (nextStep?.modalTriggers || nextStep?.path) {
				if (nextStep?.modalTriggers) modalTriggers.set(p => ({ ...p, [nextStep?.modalTriggers]: true }))
				if (nextStep?.path) nav.push(nextStep.path)
				try {
					await waitForElement(nextStep.target, 10, 100); // wait up to 10 tries
					setStepIndex(prev => prev + 1); // now advance
				} catch (err) {
					console.error(err.message);
				}
				return;
			}
			setStepIndex(prev => prev + 1);
		}
		if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
			if ((featureName === "sales" && ["bookingBooked","bookingCheckIn","propertyInquiries","productPreparing"].includes(p_name)) || (featureName === "setup" && ["setupTraining","requestedRealProperty"].includes(p_name)) || (featureName === "campaign" && ["posterTraining"].includes(p_name))) { 
				modalTriggers.set(p => ({ ...p, [p_name]: false, posterTrainingCustomize: false, posterTrainingPreview: false })) 
			}
			setStepIndex(0);
			setter();
			end(featureName, p_name);
			if (toOpenBankForm.data) {
				openBankForm.set(true)
			}
		}
	};

	const CustomTooltip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index}) => (
        <CustomTourTooltip step={step} primaryProps={primaryProps} skipProps={skipProps} backProps={backProps} tooltipProps={tooltipProps} size={size} index={index} setter={setter} controls={controls}/>
    );

    return(
        <Joyride
            continuous
            disableOverlayClose={true} 
            run={run}
            steps={steps}
			stepIndex={stepIndex}
            hideCloseButton
            showSkipButton={false}
            showProgress
            tooltipComponent={CustomTooltip}
            callback={handleCallback}
            spotlightClicks={true}
            styles={{
                spotlight:{
                    borderRadius: "11px"
                },
				options: {
					zIndex: 99999
				}
            }}
			disableScrolling={disableScrolling}
  			scrollToFirstStep={false}
			floaterProps={{
				disableFlip: true
			}}
        />
    )
}